function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import classnames from "classnames";
import { withNativeProps } from "../../utils/mergeProps";
import Button from "../button";
var classPrefix = "tc-empty";
export function createEmptyComp(imageRecord) {
  var Empty = function Empty(props) {
    var _classnames;
    var _props$status = props.status,
      status = _props$status === void 0 ? "default" : _props$status,
      _props$title = props.title,
      title = _props$title === void 0 ? "暫無數據" : _props$title,
      image = props.image,
      imageStyle = props.imageStyle,
      _props$fullPage = props.fullPage,
      fullPage = _props$fullPage === void 0 ? false : _props$fullPage,
      description = props.description,
      _props$actions = props.actions,
      actions = _props$actions === void 0 ? [] : _props$actions,
      children = props.children,
      className = props.className,
      style = props.style;
    var currentImage = image !== null && image !== void 0 ? image : imageRecord[status];
    var ImageNode = typeof currentImage === "string" ? /*#__PURE__*/React.createElement("img", {
      src: currentImage,
      style: imageStyle
    }) : currentImage;
    var emptyCls = classnames("".concat(classPrefix), (_classnames = {}, _defineProperty(_classnames, "".concat(classPrefix, "-full-page"), fullPage), _defineProperty(_classnames, "className", className), _classnames));
    var imageCls = "".concat(classPrefix, "-image");
    var descriptionCls = "".concat(classPrefix, "-description");
    var titleCls = "".concat(classPrefix, "-title");
    var buttonCls = "".concat(classPrefix, "-button");
    return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
      className: emptyCls,
      style: style
    }, /*#__PURE__*/React.createElement("div", {
      className: imageCls
    }, ImageNode), /*#__PURE__*/React.createElement("div", {
      className: titleCls
    }, title), !!description && /*#__PURE__*/React.createElement("div", {
      className: descriptionCls
    }, description), !!actions.length && /*#__PURE__*/React.createElement("div", {
      className: buttonCls
    }, actions.map(function (action) {
      var key = action.key,
        onClick = action.onClick,
        primary = action.primary,
        btnType = action.btnType,
        danger = action.danger,
        disabled = action.disabled,
        text = action.text;
      return /*#__PURE__*/React.createElement(Button, {
        key: key,
        onClick: onClick,
        className: classnames("modal-button", {
          "modal-button-primary": primary
        }),
        fill: primary ? "solid" : undefined,
        size: action.size || "middle",
        block: true,
        round: btnType === "round",
        type: danger ? "danger" : primary ? "primary" : "default",
        disabled: disabled
      }, text);
    })), children));
  };
  return Empty;
}